import { apiClient } from '../client'
import type { SubscriptionData } from "../../app/modules/types/plans"
/**
 * Subscription API endpoints
 */
export const subscriptionApi = {
  /**
   * Get current subscription
   */
  getCurrent: async (): Promise<any> => {
    const { data } = await apiClient.get('/subscription/')
    return data
  },

  /**
   * Get subscription plans
   */
  getPlans: async (): Promise<SubscriptionData> => {
    const { data } = await apiClient.get('/plans/')
    return data
  },

  /**
   * Subscribe to a plan
   */
  subscribe: async (planId: string): Promise<any> => {
    const { data } = await apiClient.post('/subscription/subscribe/', { plan_id: planId })
    return data
  },

  /**
   * Cancel subscription
   */
  cancel: async (): Promise<any> => {
    const { data } = await apiClient.post('/subscription/cancel/')
    return data
  },

  /**
   * Get subscription usage
   */
  getUsage: async (): Promise<any> => {
    const { data } = await apiClient.get('/subscription/usage/')
    return data
  },

  /**
   * Verify payment after redirect from gateway
   */
  verifyPayment: async (params: string): Promise<any> => {
    const { data } = await apiClient.get(`/subscription/verify-payment/${params}/`)
    return data
  },
}
